/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
 */
export interface GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'effectiveDayType': GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'effectiveDay': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'effectiveHours': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInner
     */
    'effectiveMinutes': number;
}

export const GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum = {
    number: 'NUMBER',
    endOfMonth: 'END_OF_MONTH'
} as const;

export type GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum = typeof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum[keyof typeof GetSlackEvidenceReminderPerChannel200ResponseSettingsInnerRemindersInnerEffectiveDayTypeEnum];


